import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FlaskConical, ShieldCheck, Microscope } from "lucide-react";

export default function About() {
    return (
        <div className="pt-32 pb-24" data-testid="about-page">
            <div className="max-w-4xl mx-auto px-6 md:px-12">
                <p className="text-pep-primary text-sm uppercase tracking-widest font-medium mb-3">About PepStep</p>
                <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl tracking-tighter text-pep-navy font-medium leading-[0.95]">
                    The next steps in your research journey, made easy.
                </h1>

                <div className="mt-12 p-8 md:p-12 bg-pep-surface rounded-3xl border border-pep-border/50">
                    <p className="text-xl md:text-2xl text-pep-navy leading-relaxed font-light">
                        We've been using peptides for years and sick of not having an easy, trustworthy and
                        reliable place to get peptides that were constantly tested and held to the highest
                        standards. A place where researchers can access heavily vetted research peptides
                        that our team has researched with ourselves. So we created PepStep.
                        <span className="block mt-4 text-pep-primary">
                            To make the next steps in your research journey easy.
                        </span>
                    </p>
                </div>

                <div className="mt-20 grid md:grid-cols-3 gap-6">
                    {[
                        { icon: FlaskConical, title: "Held to the highest standards", desc: "Independent third-party HPLC testing done regularly, above ISO standards." },
                        { icon: Microscope, title: "Researched by us", desc: "Every product on PepStep has been used and validated by our own team first." },
                        { icon: ShieldCheck, title: "Trust, by design", desc: "Transparent sourcing, full Certificates of Analysis, and discreet, tracked shipping." },
                    ].map((v, i) => (
                        <div key={i} className="p-6 rounded-3xl border border-pep-border/60 bg-white lift" data-testid={`about-value-${i}`}>
                            <div className="w-12 h-12 rounded-2xl bg-pep-primary/10 text-pep-primary flex items-center justify-center mb-4">
                                <v.icon className="w-5 h-5" />
                            </div>
                            <h3 className="font-heading text-lg font-medium text-pep-navy mb-2">{v.title}</h3>
                            <p className="text-pep-muted text-sm leading-relaxed">{v.desc}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-20 p-10 md:p-16 bg-pep-navy rounded-[2.5rem] text-white text-center">
                    <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-medium">
                        Ready to take the next step?
                    </h2>
                    <p className="text-white/60 mt-4 max-w-xl mx-auto">
                        Browse our full catalog of lab-verified research peptides — built by researchers, for researchers.
                    </p>
                    <Link
                        to="/all"
                        className="inline-flex items-center gap-2 mt-8 bg-pep-primary text-white rounded-full px-8 py-4 font-medium hover:bg-white hover:text-pep-navy transition"
                        data-testid="about-cta-shop"
                    >
                        Shop Products <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </div>
        </div>
    );
}
